import React from 'react';
const PagerView = ({ children }: any) => <>{children}</>;
//({ children }: any) => <>{children}</>;

export default PagerView;
